/**
 *
 * KycSuccess
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import Img from '../Img';
import KycSuccessImg from '../../images/upgrade_success.svg';

import messages from './messages';

import style from './style.module.scss';

function KycSuccess(props) {
  return (
    <div className={style.kycSuccess}>
      <Img className={style.successImg} src={KycSuccessImg} alt="kyc success" />
      <div className={style.heading}>
        {messages.header.defaultMessage}
      </div>
      {props.message && <div className={style.subHeading}>{props.message}</div>}
    </div>
  );
}

KycSuccess.propTypes = {
  message: PropTypes.string,
};

export default KycSuccess;
